import { isAppError } from '../utils/appErrors';

function errorChain(error: unknown): unknown[] {
  const values: unknown[] = [];
  let current = error;
  for (let depth = 0; depth < 4 && current; depth += 1) {
    values.push(current);
    if (typeof current !== 'object' || !('cause' in current)) break;
    const next = (current as { cause?: unknown }).cause;
    if (!next || next === current) break;
    current = next;
  }
  return values;
}

export function isStatementTimeoutError(error: unknown): boolean {
  return errorChain(error).some(value => {
    if (!value || typeof value !== 'object') return false;
    const candidate = value as {
      code?: unknown;
      message?: unknown;
      details?: unknown;
      hint?: unknown;
    };
    if (String(candidate.code ?? '').toUpperCase() === '57014') return true;
    const message = [candidate.message, candidate.details, candidate.hint]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return message.includes('canceling statement due to statement timeout')
      || message.includes('cancelling statement due to statement timeout');
  });
}

export function shouldRetryPrincipalQuery(failureCount: number, error: unknown): boolean {
  if (isAppError(error)) {
    if (
      error.kind === 'session_expired'
      || error.kind === 'access_denied'
      || error.kind === 'service_unavailable'
    ) {
      return false;
    }
  }
  // Retrying the same statement immediately consumes another full database
  // timeout and made Schedule take roughly three times longer to fail.
  if (isStatementTimeoutError(error)) return false;
  return failureCount < 2;
}
